<div class="powerbi-multiple-pages-component">
  <div class="report-tab-container">
    <div class="arrow left" *ngIf="showLeftArrow" (click)="scrollLeft()"><mat-icon>arrow_back_ios</mat-icon></div>
    <div class="report-tab" (window:resize)="checkArrows()" #reportTab>
      <ul>
        <ng-container *ngFor="let page of report_data?.pb_container; trackBy: trackByMenuName">
          <li (click)="SelectTab(page)" [ngClass]=" {'active' : (activeTabName?.page_name === page.page_name) }">
            {{ page.label | langtranslate}}
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="arrow right" *ngIf="showRightArrow" (click)="scrollRight()"><mat-icon>arrow_forward_ios</mat-icon></div>
  </div>
  <!-- <div class="divider" *ngIf="overViewMenu?.length && activeTabName?.child_header">
    <app-report-sub-menu [menuList]="overViewMenu"
      [activeTab]="currentScroll" (menuChangeValue)="menuChangeValue($event)">
    </app-report-sub-menu>
  </div> -->
</div>
<div class="page-view-container">
  <!-- <ng-container *ngFor="let page of report_data?.pb_container; index as i">
    <div [ngStyle]="{'display': (activeTabName?.page_name === page.page_name) ? 'block' : 'none'}">
      <div class="items">
              <div [attr.id]="page.page_name+'_page_'+page.pb_page_id" class="visual-one"
                style="width: 100%; height:100%">
              </div>
            <div class="loading-gif" *ngIf="pageLoader">
              <img src="assets/images/loading.gif" alt="" height="150px">
            </div>
        </div>
    </div>
  </ng-container> -->
    <div>
      <div class="items">
              <div [attr.id]="'pageId'" class="visual-one"
                style="width: 100%; height:100%">
              </div>
            <div class="loading-gif" *ngIf="pageLoader">
              <img src="assets/images/loading.gif" alt="" height="150px">
            </div>
        </div>
    </div>

</div>
